import { FiAlertTriangle } from "react-icons/fi"

type AdminAlertProps = {
    message?: string
}

export const AdminAlert = ({ message}: AdminAlertProps) => {

    if (message == undefined || message.length < 1) {
        return <></>
    }

    return (
        <div className='infoMessage admin-alert'>
            <div className='error'>
                <div className='infoMessage__icon'>
                    <FiAlertTriangle color='red' size='20' />
                </div>
                <div className='infoMessage__icon' dangerouslySetInnerHTML={{ __html: message }} />
            </div>
        </div>
        )
}
